import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const before = ['Spending hours planning every lesson from scratch', 'Improvising drills the moment the group size changes', 'No objective way to prove a student has progressed', 'Repeating the same three exercises for months', 'Losing students who never see themselves improving'];
const after = ['Open the volume, run the lesson, close the volume', 'Every drill has group variants for 2, 4 and 8 players', 'A scored entry and exit assessment for every level', '132 numbered drills, sequenced across eight weeks', 'Printable progress reports parents actually read'];
export function BeforeAfterSection() {
  return <section className="bg-white px-5 py-14 md:py-24" data-id="element-32" data-mp="13ov2a320hbsu">
      <Reveal className="mx-auto max-w-container" data-id="element-33" data-mp="3adribj5drgcm">
        <div className="overflow-hidden rounded-card border border-tr-border bg-tr-cream/60 shadow-card" data-id="element-34" data-mp="3aejdwtyz9e2w">
          <div className="grid md:grid-cols-2" data-id="element-35" data-mp="35grbh60pi9kg">
            <div className="p-7 md:p-10" data-id="element-36" data-mp="36p1oex5yscyp">
              <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-tr-grey/70" data-id="element-37" data-mp="36q2yozf5ovfd">
                The way most coaches plan right now
              </p>
              <h3 className="mt-2 text-xl font-bold tracking-tight text-tr-navy" data-id="element-38" data-mp="3glo99lyaj40q">
                BEFORE
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-39" data-mp="3lez4sqxnjydc">
                {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-40" data-mp="3pe80w2g608c2">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-tr-border/70" data-id="element-41" data-mp="3udkvj9da2jp7">
                      <XIcon className="h-3.5 w-3.5 text-tr-grey" aria-hidden="true" data-id="element-42" data-mp="394dun3w52zu" />
                    </span>
                    <span className="text-[15px] leading-snug text-tr-grey" data-id="element-43" data-mp="24zxzns4h2gga">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="relative border-t border-tr-border bg-white p-7 md:border-l md:border-t-0 md:p-10" data-id="element-44" data-mp="21ymdhtgdzneu">
              <span className="absolute right-6 top-6 flex h-9 w-9 items-center justify-center rounded-full bg-tr-green/12 text-tr-green" aria-hidden="true" data-id="element-45" data-mp="1x01dnv51r5qx">
                <CheckIcon className="h-4 w-4" data-id="element-46" data-mp="26v354xmsojwo" />
              </span>
              <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-tr-green" data-id="element-47" data-mp="2kvnopw0jajr8">
                The smarter way to teach
              </p>
              <h3 className="mt-2 text-xl font-bold tracking-tight text-tr-navy" data-id="element-48" data-mp="2fvhzemhql9cb">
                WITH TENNIS READY
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-49" data-mp="2pmvumi2nnmzn">
                {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-50" data-mp="33mf2ravguyby">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-tr-green/12" data-id="element-51" data-mp="33kkfvr0mww58">
                      <CheckIcon className="h-3.5 w-3.5 text-tr-green" aria-hidden="true" data-id="element-52" data-mp="3i9vo3vtijuvf" />
                    </span>
                    <span className="text-[15px] font-medium leading-snug text-tr-navy" data-id="element-53" data-mp="398xqpwdkyllt">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
        <p className="mt-6 text-center font-accent text-[15px] italic text-tr-grey" data-id="element-54" data-mp="2ziclhq3eiitx">
          A complete, done-for-you teaching system — built for real groups, real
          courts and real time.
        </p>
      </Reveal>
    </section>;
}